import createHttpClient from './httpClient'

function createLoginService() {
  let http

  function configure(props) {
    http = createHttpClient({ csrfToken: props.csrfToken, env: props.env })
  }

  function login({
    email = '',
    password = '',
    redirectTo = '',
    loginChallenge = '',
    zendeskLogin = '',
    recaptchaToken = '',
    recaptchaError = false,
    ledgerUuid = '',
    remember = false,
  }) {
    const payload = {
      email,
      password,
      redirect_to: redirectTo,
      login_challenge: loginChallenge,
      zendesk_login: zendeskLogin,
      ledger_uuid: ledgerUuid,
      remember,
    }

    if (recaptchaError) payload.recaptcha_error = true
    if (recaptchaToken) payload.recaptcha_token = recaptchaToken

    return http.post('/api/v1/login', payload)
  }

  function ssoLogin({ email = '', redirectTo = '' }) {
    return http.post('/api/v1/auth/saml/initiate_login', { email, redirect_to: redirectTo })
  }

  function recoverPassword({ email = '' }) {
    return http.post('/api/v1/forgot_password', { email })
  }

  function loginJWT({ email = '', jwt = '', redirectTo = '' }) {
    return http.post('/api/v1/jwt_login', { email, jwt, redirect_to: redirectTo })
  }

  function mfaLogin({ email = '', totpCode, redirectTo = '', enableMfaApp = false }) {
    return http.post('/api/v1/mfa_app/login', {
      email,
      totp_code: totpCode,
      enable_mfa_app: enableMfaApp,
      redirect_to: redirectTo,
    })
  }

  function deviceApprovalLogin({ code = '' }) {
    return http.post('/api/v1/device_approval', {
      code,
    })
  }

  function resendDeviceApprovalCode() {
    return http.post('/api/v1/device_approval/resend', {})
  }
  return {
    configure,
    login,
    ssoLogin,
    mfaLogin,
    recoverPassword,
    loginJWT,
    deviceApprovalLogin,
    resendDeviceApprovalCode,
  }
}

export default createLoginService()
